import LargeCarousel from 'components/Content/BannerListLayout/LargeCarousel/LargeCarousel';
import SmallCarousel from 'components/Content/BannerListLayout/SmallCarousel/SmallCarousel';
import GridLayout from 'components/Content/BannerListLayout/GridLayout/GridLayout';

export default {
    LargeCarousel,
    SmallCarousel,
    GridLayout
};
